import { IAppointmentsReport } from '../../../interface/IAppointmentsReport'
import { IAPIAppointmentsReport } from '../../interface/IAPIAppointmentsReport'

import { getGroupByNumber } from './getGroupByNumber'

export const createGroupData = (
    apiData: IAPIAppointmentsReport[],
    groupNumber: number,
    type: string
): IAppointmentsReport => {

    const groupData = apiData.find(
        (data) => getGroupByNumber(data.date_by_period, type) === groupNumber
    )

    if (typeof groupData === 'undefined') {
        return {
            online: 0,
            phone: 0,
            noAppointment: 0,
            register: 0,
            groupByNumber: groupNumber
        }
    }

    return {
        online: groupData.online_appointments,
        phone: groupData.appointments_by_phone,
        register: groupData.appointments_after_receipt,
        noAppointment: groupData.receipts_without_appointment,
        groupByNumber: groupNumber
    }
}
